"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _league_level = _interopRequireDefault(require("./league_level"));
var _user_league = _interopRequireDefault(require("./user_league"));
var _root_model = _interopRequireDefault(require("./root_model"));
var _serializr = require("serializr");
var _moment = _interopRequireDefault(require("moment"));
var _serializer_helpers = require("./utils/serializer_helpers");
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var League = (_dec = (0, _serializr.serializable)((0, _serializer_helpers.staticDateDecoratorOrNull)()), _dec2 = (0, _serializr.serializable)((0, _serializer_helpers.staticDateDecoratorOrNull)()), _dec3 = (0, _serializr.serializable)((0, _serializer_helpers.staticDateDecoratorOrNull)()), _dec4 = (0, _serializr.serializable)((0, _serializr.object)(_league_level["default"])), _dec5 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_user_league["default"]))), _class = /*#__PURE__*/function (_RootModel) {
  function League() {
    var _this;
    _classCallCheck(this, League);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, League, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "usersCount", _descriptor2, _this);
    _initializerDefineProperty(_this, "active", _descriptor3, _this);
    _initializerDefineProperty(_this, "endTime", _descriptor4, _this);
    _initializerDefineProperty(_this, "createdAt", _descriptor5, _this);
    _initializerDefineProperty(_this, "updatedAt", _descriptor6, _this);
    _initializerDefineProperty(_this, "leagueLevel", _descriptor7, _this);
    _initializerDefineProperty(_this, "userLeagues", _descriptor8, _this);
    return _this;
  }
  _inherits(League, _RootModel);
  return _createClass(League, [{
    key: "timeFromNow",
    get: function get() {
      if (!this.endTime || !this.endTime.dateObj) return null;
      var now = (0, _moment["default"])();
      var end = (0, _moment["default"])(this.endTime.dateObj);
      var duration = _moment["default"].duration(end.diff(now));
      var days = Math.round(duration.asDays());
      var hours = Math.round(duration.asHours());
      var minutes = Math.round(duration.asMinutes());
      if (days > 1) {
        return "".concat(days, " ").concat(days === 1 ? 'day' : 'days');
      } else if (hours > 1) {
        return "".concat(hours, " ").concat(hours === 1 ? 'hour' : 'hours');
      } else if (minutes > 0) {
        return "".concat(minutes, " ").concat(minutes === 1 ? 'minute' : 'minutes');
      } else {
        return 'now';
      }
    }
  }, {
    key: "ended",
    get: function get() {
      var _this$endTime;
      return this.endTime && ((_this$endTime = this.endTime) === null || _this$endTime === void 0 ? void 0 : _this$endTime.dateObj) < new Date();
    }
  }, {
    key: "duration",
    get: function get() {
      if (!this.endTime || !this.endTime.dateObj) return null;
      var duration = _moment["default"].duration((0, _moment["default"])(this.endTime.dateObj).diff(this.createdAt.dateObj));
      var days = Math.floor(duration.asDays());
      var hours = duration.hours();
      if (days === 0) {
        return "".concat(hours, " ").concat(hours === 1 ? 'hour' : 'hours');
      }
      return "".concat(days, " ").concat(days === 1 ? 'day' : 'days', " ").concat(hours, " ").concat(hours === 1 ? 'hour' : 'hours');
    }
  }, {
    key: "highestXp",
    get: function get() {
      var _this$userLeagues;
      return (_this$userLeagues = this.userLeagues) === null || _this$userLeagues === void 0 ? void 0 : _this$userLeagues.reduce(function (max, userLeague) {
        return Math.max(max, userLeague.xp);
      }, 0);
    }
  }, {
    key: "averageXp",
    get: function get() {
      var _this$userLeagues2;
      return Math.ceil(((_this$userLeagues2 = this.userLeagues) === null || _this$userLeagues2 === void 0 ? void 0 : _this$userLeagues2.reduce(function (sum, userLeague) {
        return sum + userLeague.xp;
      }, 0)) / this.userLeagues.length);
    }
  }, {
    key: "rank",
    value: function rank(user) {
      var userLeague = this.userLeagues.find(function (ul) {
        return ul.userId === user.id;
      });
      if (!userLeague) {
        return null;
      }
      return userLeague.rank;
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "usersCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "active", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "endTime", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_mobx.observable, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "leagueLevel", [_mobx.observable, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "userLeagues", [_mobx.observable, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "timeFromNow", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "timeFromNow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "ended", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "ended"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "duration", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "duration"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "highestXp", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "highestXp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "averageXp", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "averageXp"), _class.prototype), _class);
var _default = exports["default"] = League;